const routes = [
    {
        path: "/car/reservations/empty-reservations",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'carreservation_index'
        }
    }
];

export default routes;
